import { Bar } from 'react-chartjs-2';
import Colors from 'assets/Colors';
import Loading from 'components/common/loading';
import s from './styles';

const options = () => ({
  plugins: {
    tooltip: {
      callbacks: {
        label: (tooltipItem) => {
          const datasetIndex = tooltipItem.datasetIndex;
          return `${tooltipItem.raw} ${datasetIndex === 0 ? "€" : ""}`;
        },
      },
    },
    legend: {
      display: false,
    },
    datalabels: {
      labels: {
        title: null,
      },
    },
  },
  responsive: true,
  maintainAspectRatio: false,

  scales: {},
});

function getGradient(ctx, chartArea) {
  const gradient = ctx.createLinearGradient(
    0,
    chartArea.bottom,
    0,
    chartArea.top
  );
  gradient.addColorStop(0, Colors.primary_web_color1);
  gradient.addColorStop(1, Colors.primary_web_color2);

  return gradient;
}

function LineChart({ list = [], title = '', loading }) {
  const data = {
    labels: list.map((element) => element.label),
    datasets: [
      {
        data: list.map((element) => element.number),
        backgroundColor(context) {
          const { chart } = context;
          const { ctx, chartArea } = chart;
          if (!chartArea) {
            return null;
          }
          return getGradient(ctx, chartArea);
        },
      },
    ],
  };

  return (
    <s.Container>
      {loading ? (
        <Loading height="200px" size="middle" />
      ) : (
        <div
          style={{
            height: '100%',
            width: '100%',
          }}
        >
          <s.Title>{title}</s.Title>
          <Bar data={data} options={options()} />
        </div>
      )}
    </s.Container>
  );
}

export default LineChart;
